// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-stock-bucket {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.add-stock-bucket h2 {
  margin: 0 0 16px;
  font-size: 1.125rem;
  color: #1a1a2e;
}

.add-stock-bucket .mode-toggle {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.add-stock-bucket .mode-option {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  transition: background 0.15s, border-color 0.15s;
}

.add-stock-bucket .mode-option:hover {
  background: #f3f4f6;
}

.add-stock-bucket .mode-option.active {
  background: #e0e7ff;
  border-color: #4f46e5;
  color: #1e1b4b;
}

.add-stock-bucket .mode-option input[type="radio"] {
  accent-color: #4f46e5;
}

.add-stock-bucket .form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.add-stock-bucket .form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.add-stock-bucket .form-group label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
}

.add-stock-bucket .form-group input,
.add-stock-bucket .form-group select {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.875rem;
  min-width: 200px;
}

.add-stock-bucket .warehouse-search {
  position: relative;
}

.add-stock-bucket .warehouse-search input {
  width: 100%;
  box-sizing: border-box;
}

.add-stock-bucket .warehouse-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  z-index: 10;
}

.add-stock-bucket .warehouse-dropdown .wh-option {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.875rem;
}

.add-stock-bucket .warehouse-dropdown .wh-option:hover {
  background: #e5e7eb;
}

.add-stock-bucket .selected-items {
  margin-top: 12px;
}

.add-stock-bucket .selected-items h3 {
  font-size: 0.95rem;
  margin: 0 0 8px;
}

.add-stock-bucket .selected-items table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.add-stock-bucket .selected-items th,
.add-stock-bucket .selected-items td {
  text-align: left;
  padding: 6px 10px;
  border-bottom: 1px solid #e5e7eb;
}

.add-stock-bucket .selected-items th {
  background: #f3f4f6;
  font-weight: 600;
}

.add-stock-bucket .btn-remove {
  padding: 4px 10px;
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.add-stock-bucket .btn-remove:hover {
  background: #b91c1c;
}

.add-stock-bucket .btn-save {
  margin-top: 16px;
  padding: 10px 24px;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
}

.add-stock-bucket .btn-save:hover {
  background: #1d4ed8;
}

.add-stock-bucket .btn-save:disabled {
  opacity: 0.5;
  cursor: default;
}

.add-stock-bucket .error {
  color: #dc2626;
  font-size: 0.85rem;
  margin-top: 8px;
}

.add-stock-bucket .success {
  color: #16a34a;
  font-size: 0.85rem;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AddStockBucket.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".add-stock-bucket {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.add-stock-bucket h2 {\n  margin: 0 0 16px;\n  font-size: 1.125rem;\n  color: #1a1a2e;\n}\n\n.add-stock-bucket .mode-toggle {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.add-stock-bucket .mode-option {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.add-stock-bucket .mode-option:hover {\n  background: #f3f4f6;\n}\n\n.add-stock-bucket .mode-option.active {\n  background: #e0e7ff;\n  border-color: #4f46e5;\n  color: #1e1b4b;\n}\n\n.add-stock-bucket .mode-option input[type=\"radio\"] {\n  accent-color: #4f46e5;\n}\n\n.add-stock-bucket .form-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.add-stock-bucket .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.add-stock-bucket .form-group label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.add-stock-bucket .form-group input,\n.add-stock-bucket .form-group select {\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  min-width: 200px;\n}\n\n.add-stock-bucket .warehouse-search {\n  position: relative;\n}\n\n.add-stock-bucket .warehouse-search input {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.add-stock-bucket .warehouse-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 200px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  z-index: 10;\n}\n\n.add-stock-bucket .warehouse-dropdown .wh-option {\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.add-stock-bucket .warehouse-dropdown .wh-option:hover {\n  background: #e5e7eb;\n}\n\n.add-stock-bucket .selected-items {\n  margin-top: 12px;\n}\n\n.add-stock-bucket .selected-items h3 {\n  font-size: 0.95rem;\n  margin: 0 0 8px;\n}\n\n.add-stock-bucket .selected-items table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.add-stock-bucket .selected-items th,\n.add-stock-bucket .selected-items td {\n  text-align: left;\n  padding: 6px 10px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.add-stock-bucket .selected-items th {\n  background: #f3f4f6;\n  font-weight: 600;\n}\n\n.add-stock-bucket .btn-remove {\n  padding: 4px 10px;\n  background: #dc2626;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.add-stock-bucket .btn-remove:hover {\n  background: #b91c1c;\n}\n\n.add-stock-bucket .btn-save {\n  margin-top: 16px;\n  padding: 10px 24px;\n  background: #2563eb;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.add-stock-bucket .btn-save:hover {\n  background: #1d4ed8;\n}\n\n.add-stock-bucket .btn-save:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.add-stock-bucket .error {\n  color: #dc2626;\n  font-size: 0.85rem;\n  margin-top: 8px;\n}\n\n.add-stock-bucket .success {\n  color: #16a34a;\n  font-size: 0.85rem;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
